import { EventType, IContent, IEventRelation, MatrixEvent, MatrixEventEvent, RelationType } from "matrix-js-sdk";
import { Reaction } from "./reaction";
import { RelatesToRelationship } from "matrix-js-sdk/lib/@types/extensible_events";
import { MatrixService } from "../_services/matrix.service";

export class Message {
    get sender() {
        return this.event.sender!
    }

    get content(): IContent {
        return this.event.event.content!
    }

    private _reactions: Array<Reaction> = [];
    get reactions() {
        if (this.roomCreated) return [];
        if (!this._reactions) {
            this._reactions = this.event.event.event_id ? Array.from(this.matrix.reations.get(this.event.event.event_id)?.values() || []) : [];
            return this._reactions;
        } else {
            let reactions = this.event.event.event_id ? Array.from(this.matrix.reations.get(this.event.event.event_id)?.values() || []) : [];
            if (reactions !== this._reactions) this._reactions = reactions;
            return this._reactions;
        }
    }

    messageId: string;
    roomCreated = false;
    redacted = false;
    time: Date;
    type: EventType;
    relation?: IEventRelation

    get isRequest() {
        return this.event.event.content?.msgtype === 'm.paymentrequest'
    }

    constructor(
        private matrix : MatrixService,
        public event: MatrixEvent
    ) {
        this.type = <EventType>event.getType();

        if (![EventType.RoomMessage, EventType.RoomCreate, EventType.RoomMember].includes(this.type)) throw new Error("Wrong Event type");

        this.time = new Date(event.localTimestamp);
        // console.log('MESSAGE', event.event);
        if (this.type == EventType.RoomCreate) this.roomCreated = true;
        if ((<any>event.event)['redacted_because']) this.redacted = true;
        if (this.content["m.relates_to"]) this.relation = this.content["m.relates_to"];
        event.on(MatrixEventEvent.BeforeRedaction, (ev) => {
            this.redacted = true;
        })
        this.messageId = event.event.event_id!
    }
}